var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOprAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7332 13C23.7332 19.1856 18.7188 24.2 12.5332 24.2C6.34766 24.2 1.33325 19.1856 1.33325 13C1.33325 6.81441 6.34766 1.8 12.5332 1.8C18.7188 1.8 23.7332 6.81441 23.7332 13Z",
    fill: "#E8D420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5332 13V7.4M12.5332 17.1508V17.2M23.7332 13C23.7332 19.1856 18.7188 24.2 12.5332 24.2C6.34766 24.2 1.33325 19.1856 1.33325 13C1.33325 6.81441 6.34766 1.8 12.5332 1.8C18.7188 1.8 23.7332 6.81441 23.7332 13Z",
    stroke: "#324658",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOprAlertIcon);
export default __webpack_public_path__ + "static/media/OprAlertIcon.b33a57aaf916e28369838e8f58b50369.svg";
export { ForwardRef as ReactComponent };